<template>
	<sf-content-layout>
		<template v-slot:location>
			<sf-location :locations="locations" />
		</template>
		<template v-slot:title>
			<sf-content-title :title="getMessage_(screen.menuTitle)" useFavorite :favorite="screen.favoriteYn === 'Y'" :onFavorite="onFavorite" />
		</template>
		<template v-slot:titleEnd>
			<sf-button v-if="isButton_(scrId, 'AD')" :onClick="RegisterAction">{{ getButtonMsg_(scrId, 'AD') }}</sf-button>
		</template>
		<template v-slot:content>
			<notification-content :scrId="scrId" />
			<notification-modal :scrId="scrId" />
		</template>
	</sf-content-layout>
</template>

<script>
// 삭제 기능이 실 data 삭제가 아닌 useYn:'N' 변경으로 실제 기능 무의미하여 주석 처리함 //eyshin

import NotificationContent from './Content/Content';
import NotificationModal from './Content/Modal/NotificationModal';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/Notification/store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {}
		};
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
	},
	components: { NotificationContent, NotificationModal },

	computed: {
		...serviceComputed,
		...rootComputed,

		locations() {
			let result = [];
			if (this.screen && this.screen.menuLocation) {
				result = this.screen.menuLocation.map(str => this.getMessage_(str));
			}

			return result;
		}
	},

	methods: {
		...serviceMethods,
		...rootMethods,

		onFavorite() {
			this.$sf_toggleLoading(true);
			this.onFavorite_()
				.then(header => {
					this.$sf_showMessage({
						...this.$sf_setMessageOption(header),
						message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
					});
				})
				.catch(error => {
					this.$sf_showMessage({ title: 'Error', icon: 'error', message: error.message });
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},

		RegisterAction() {
			this.setState_({ key: 'notificationsModal', value: { opened: true } });
		}
	},
	beforeDestroy() {
		this.resetState_();
	}
};
</script>
